export default __webpack_public_path__ + "static/media/EstacoesIconWhite.f62e4d52.svg";